export const FETCH_COMPANIES = 'Companies/FETCH_COMPANIES'
export const FETCH_COMPANIES_SUCCESS = 'Companies/FETCH_COMPANIES_SUCCESS'
export const FETCH_COMPANIES_ERROR = 'Companies/FETCH_COMPANIES_ERROR'
export const FETCH_COMPANIES_DONE = 'Companies/FETCH_COMPANIES_DONE'
